/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_University_AriaInputs */

const en_homepage_university_aria = /** @type {(inputs: Homepage_University_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Academic Institutions`)
};

const es_homepage_university_aria = /** @type {(inputs: Homepage_University_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instituciones académicas destacadas`)
};

/**
* | output |
* | --- |
* | "Featured Academic Institutions" |
*
* @param {Homepage_University_AriaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_university_aria = /** @type {((inputs?: Homepage_University_AriaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_University_AriaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_university_aria(inputs)
	return en_homepage_university_aria(inputs)
});